// Game settings (spec/dashboard.md section 12.4): `games/:game/settings/:tab?` with the tabs General · Members · Keys ·
// Webhooks (M7 slice 5) · Audit, each a URL segment.
import { useParams } from 'react-router';
import { useGame } from '../../shell/GameContext';
import { routes } from '../../shell/routes';
import { Tabs } from '../../ui/Tabs';
import { AuditTab } from './AuditTab';
import { GeneralTab } from './GeneralTab';
import { KeysTab } from './KeysTab';
import { MembersTab } from './MembersTab';
import { WebhooksTab } from './WebhooksTab';
import './settings.css';
import { EmptyState } from '../../ui/Banner';
import { Settings } from '../../ui/icons';

type Tab = 'general' | 'members' | 'keys' | 'webhooks' | 'audit';
const TABS: { key: Tab; label: string }[] = [
  { key: 'general', label: 'General' },
  { key: 'members', label: 'Members' },
  { key: 'keys', label: 'Keys' },
  { key: 'webhooks', label: 'Webhooks' },
  { key: 'audit', label: 'Audit' },
];

export function SettingsPage() {
  const { tab: raw } = useParams();
  const { org, game } = useGame();
  const tab: Tab | null = raw === undefined ? 'general' : TABS.some((t) => t.key === raw) ? (raw as Tab) : null;
  return (
    <section data-testid="settings" className="settings-page">
      <div className="page-head">
        <h1>Settings</h1>
        <span className="page-sub">{game.name}</span>
      </div>
      <Tabs ariaLabel="Game settings" value={tab ?? undefined} items={TABS.map((t) => ({ key: t.key, label: t.label, to: routes.settings(org, game.slug, t.key) }))} />
      {tab === 'general' && <GeneralTab key={game.id} />}
      {tab === 'members' && <MembersTab />}
      {tab === 'keys' && <KeysTab />}
      {tab === 'webhooks' && <WebhooksTab />}
      {tab === 'audit' && <AuditTab />}
      {tab === null && <EmptyState icon={<Settings />} title={`No settings tab “${raw}”.`} body="Pick one of the tabs above." />}
    </section>
  );
}
